import React from 'react';
import { Link, useLocation } from 'react-router';
import { skillCategories } from './skillCatalog';

const SkillsSection = () => {
  const location = useLocation();
  
  return (
    <section id="skills" className="py-8 bg-black">
      <div className="px-8 md:px-12 lg:px-16">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
          Skills & Technologies
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 max-w-7xl mx-auto">
          {skillCategories.map((category) => (
            <div key={category.title}>
              <h3 className="text-lg font-semibold text-white mb-4 border-b border-gray-700 pb-2">
                {category.title}
              </h3>
              <ul className="space-y-2">
                {category.skills.map((skill) => (
                  <li key={skill} className="text-gray-300 text-sm">
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Featured Certification Callout */}
        <div className="mt-8 flex justify-center">
          <div className="max-w-7xl w-full">
            <div className="p-8 md:p-12 lg:p-16 relative">
              {/* Star rating at top */}
              <div className="text-center mb-3 md:mb-4">
                <div className="flex justify-center items-center space-x-2 md:space-x-3 text-white text-2xl md:text-3xl lg:text-4xl">
                  <span>★</span>
                  <span>★</span>
                  <img 
                    src="/assets/PLTR.png" 
                    alt="Palantir Logo" 
                    className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 object-contain"
                  />
                  <span>★</span>
                  <span>★</span>
                </div>
              </div>
              
              <div className="text-center space-y-2 md:space-y-3 lg:space-y-4">
                <div className="text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-white tracking-wider uppercase" style={{fontFamily: 'Impact, "Arial Black", sans-serif'}}>
                  PALANTIR FOUNDRY & AIP
                </div>
                
                <div className="text-xl md:text-3xl lg:text-4xl font-bold text-red-300 tracking-widest uppercase" style={{fontFamily: 'Impact, "Arial Black", sans-serif'}}>
                  CERTIFIED · 2026
                </div>
              </div>
              
              {/* Mobile bottom content - stacked layout */}
              <div className="md:hidden mt-12 flex flex-col space-y-3">
                <div className="text-xs uppercase tracking-[0.3em] text-gray-400 font-bold italic text-center" style={{fontFamily: 'Georgia, "Times New Roman", serif'}}>
                  "THE ONLY OFFICIAL CERTIFICATION FOR PALANTIR"
                </div>
                
                <Link 
                  to="/experience/fox"
                  state={{ background: location }}
                  className="flex items-center justify-center space-x-2 text-xs text-gray-400 hover:text-red-300 transition-colors duration-200 group"
                  style={{fontFamily: 'Georgia, "Times New Roman", serif'}}
                >
                  <span className="group-hover:text-red-300">Courtesy of</span>
                  <span className="font-semibold text-white group-hover:text-red-300">Ontologize</span>
                  <span className="group-hover:text-red-300">and</span>
                  <span className="font-semibold text-white group-hover:text-red-300">FOX</span>
                </Link>
              </div>

              {/* Desktop bottom content - absolute positioned */}
              <div className="hidden md:block">
                {/* Quote positioned bottom left */}
                <div className="absolute -bottom-2 left-8 lg:left-12 text-sm lg:text-base uppercase tracking-[0.4em] text-gray-400 font-bold italic" style={{fontFamily: 'Georgia, "Times New Roman", serif'}}>
                  "THE ONLY OFFICIAL CERTIFICATION FOR PALANTIR"
                </div>
                
                {/* Credit line positioned bottom right */}
                <Link 
                  to="/experience/fox"
                  state={{ background: location }}
                  className="absolute -bottom-2 right-8 lg:right-12 flex items-center space-x-2 text-sm lg:text-base text-gray-400 hover:text-red-300 transition-colors duration-200 group"
                  style={{fontFamily: 'Georgia, "Times New Roman", serif'}}
                >
                  <span className="group-hover:text-red-300">Courtesy of</span>
                  <span className="font-semibold text-white group-hover:text-red-300">Ontologize</span>
                  <span className="group-hover:text-red-300">and</span>
                  <span className="font-semibold text-white group-hover:text-red-300">FOX</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
